import Vue from "vue";
import Router from "vue-router";

import store from "@/state";

import Alert from "./pages/Alerts/Alert/index";
import Alerts from "./pages/Alerts/index";
import AlertEvents from "./pages/Alerts/Events";
import AlertEdit from "./pages/Alerts/Alert/Edit";

import BillingPortal from "./pages/Account/BillingPortal";

import PasswordReset from "./pages/PasswordReset/index";
import PasswordResetEmailSent from "./pages/PasswordReset/EmailSent";
import PasswordResetSetPassword from "./pages/PasswordReset/SetPassword";

import Invitation from "./pages/Invitation";

import SignIn from "./pages/SignIn";

import SignUp from "./pages/SignUp/index";
import SignUpSuccess from "./pages/SignUp/Success";
import PoolSelection from "./pages/SignUp/poolSelection";
import IngestPaymentMethod from "./pages/SignUp/ingestPaymentMethod";

import ConfirmCharge from "./pages/SignUp/ConfirmCharge";
import OnboardingComplete from "./pages/SignUp/OnboardingComplete";

import VerifyEmail from "./pages/VerifyEmail";

import Overview from "./pages/Overview";
import FullScreen from "./pages/FullScreen";

import Groups from "./pages/Groups/index";
import Group from "./pages/Groups/Group/index";
import GroupEdit from "./pages/Groups/Group/Edit";

import Workers from "./pages/Workers/index";
import WorkersBulkCreate from "./pages/Workers/BulkCreate";
import Worker from "./pages/Workers/Worker/index";
import WorkerEdit from "./pages/Workers/Worker/Edit";

import Facilities from "./pages/Facilities/index";
import Facility from "./pages/Facilities/Facility/index";

import Contracts from "./pages/Contracts/index";
import Contract from "./pages/Contracts/Contract/index";
import ContractEdit from "./pages/Contracts/Contract/Edit";
import OnboardNewContract from "./pages/Contracts/Contract/OnboardNewContract";
import ContractFacilities from "./pages/ContractFacilities/index";
import ContractFacilitiesEdit from "./pages/ContractFacilities/Edit";

import AccountGeneral from "./pages/Account/General/index";
import AccountInvitations from "./pages/Account/Invitations";
import AccountSecurity from "./pages/Account/Security";

import TeamGeneral from "./pages/Team/General/index";
import TeamInvitations from "./pages/Team/Invitations/index";

import TeamMembers from "./pages/Team/Members/index";
import TeamMember from "./pages/Team/Members/Member";

import Roles from "./pages/Team/Roles/index";
import Role from "./pages/Team/Roles/Role/index";
import RoleEdit from "./pages/Team/Roles/Role/Edit";

import PageNotFound from "./pages/PageNotFound";

import Help from "./pages/Help/index";
import HelpFAQ from "./pages/Help/FAQ";

import ReactorCapacity from "./pages/ReactorAdmin/Capacity";
import ReactorContracts from "./pages/ReactorAdmin/Contracts";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 75 } };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/sign-in",
      component: SignIn,
      name: "signIn",
      meta: {
        title: "Sign In - Mine.App",
      },
    },
    {
      path: "/password-reset",
      component: PasswordReset,
      name: "passwordReset",
      meta: {
        title: "Reset Password - Mine.App",
      },
    },
    {
      path: "/password-reset/email-sent",
      component: PasswordResetEmailSent,
      name: "passwordResetEmailSent",
      meta: {
        title: "Reset Password - Mine.App",
      },
    },
    {
      path: "/password-reset/set-password",
      component: PasswordResetSetPassword,
      name: "passwordResetSetPassword",
      meta: {
        title: "Reset Password - Mine.App",
      },
    },
    {
      path: "/sign-up",
      component: SignUp,
      name: "signUp",
      meta: {
        title: "Sign Up - Mine.App",
      },
    },
    {
      path: "/pool-selection",
      component: PoolSelection,
      name: "Pool Selection",
      meta: {
        title: "Pool Selection - Mine.App",
      },
    },
    {
      path: "/ingest-payment-method",
      component: IngestPaymentMethod,
      name: "Ingest Payment Method",
      meta: {
        title: "Ingest Payment Method - Mine.App",
      },
    },
    {
      path: "/sign-up/success",
      component: SignUpSuccess,
      name: "signUpSuccess",
      meta: {
        title: "Sign Up - Mine.App",
      },
    },
    {
      path: "/confirm-charge",
      component: ConfirmCharge,
      name: "confirmCharge",
      meta: {
        title: "Confirm Charge - Mine.App",
      },
    },
    {
      path: "/onboarding-complete",
      component: OnboardingComplete,
      name: "onboardingComplete",
      meta: {
        title: "Onboarding Complete - Mine.App",
      },
    },
    {
      path: "/verify",
      component: VerifyEmail,
      name: "verify",
      meta: {
        title: "Verify - Mine.App",
      },
    },
    {
      path: "/invitations/:invitationId",
      component: Invitation,
      name: "invitation",
      meta: {
        title: "Invitation - Mine.App",
      },
    },
    {
      path: "/",
      component: Overview,
      name: "overview",
      meta: {
        title: "Overview - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/fullscreen",
      component: FullScreen,
      props: true,
      name: "fullscreen",
      meta: {
        title: "Overview - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/groups",
      component: Groups,
      name: "groups",
      meta: {
        title: "Groups - Mine.App",
        requiresAuth: true,
        access: {
          entity: "groups",
          action: "view",
        },
      },
    },
    {
      path: "/groups/create",
      component: GroupEdit,
      name: "groupsCreate",
      meta: {
        title: "Groups - Mine.App",
        requiresAuth: true,
        access: {
          entity: "groups",
          action: "edit",
          fallback: "/groups",
        },
      },
    },
    {
      path: "/groups/:groupId",
      component: Group,
      name: "group",
      meta: {
        title: "Groups - Mine.App",
        requiresAuth: true,
        access: {
          entity: "groups",
          action: "view",
        },
      },
    },
    {
      path: "/groups/:groupId/edit",
      component: GroupEdit,
      name: "groupEdit",
      meta: {
        title: "Groups - Mine.App",
        requiresAuth: true,
        access: {
          entity: "groups",
          action: "edit",
          fallback: "/groups",
        },
      },
    },
    {
      path: "/facilities",
      component: Facilities,
      name: "facilities",
      meta: {
        title: "Facilities - Mine.App",
        requiresAuth: true,
        access: {
          entity: "facilities",
          action: "view",
        },
      },
    },
    {
      path: "/facilities/:facilityId",
      component: Facility,
      name: "facility",
      meta: {
        title: "Facilities - Mine.App",
        requiresAuth: true,
        access: {
          entity: "facilities",
          action: "view",
        },
      },
    },
    {
      path: "/billing-portal",
      component: BillingPortal,
      name: "billingPortal",
      meta: {
        title: "Billing Portal - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/workers",
      component: Workers,
      name: "workers",
      meta: {
        title: "Workers - Mine.App",
        requiresAuth: true,
        access: {
          entity: "workers",
          action: "view",
        },
      },
    },
    {
      path: "/workers/bulk-create",
      component: WorkersBulkCreate,
      name: "workersBulkCreate",
      meta: {
        title: "Workers - Mine.App",
        requiresAuth: true,
        access: {
          entity: "workers",
          action: "edit",
          fallback: "/workers",
        },
      },
    },
    {
      path: "/workers/create",
      component: WorkerEdit,
      name: "workersCreate",
      meta: {
        title: "Workers - Mine.App",
        requiresAuth: true,
        access: {
          entity: "workers",
          action: "edit",
          fallback: "/workers",
        },
      },
    },
    {
      path: "/workers/:workerId",
      component: Worker,
      name: "worker",
      meta: {
        title: "Workers - Mine.App",
        requiresAuth: true,
        access: {
          entity: "workers",
          action: "view",
        },
      },
    },
    {
      path: "/workers/:workerId/edit",
      component: WorkerEdit,
      name: "workerEdit",
      meta: {
        title: "Workers - Mine.App",
        requiresAuth: true,
        access: {
          entity: "workers",
          action: "edit",
          fallback: "/workers",
        },
      },
    },
    {
      path: "/contracts",
      component: Contracts,
      name: "contracts",
      meta: {
        title: "Contracts - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/contracts/create",
      component: ContractEdit,
      name: "contractCreate",
      meta: {
        title: "Contracts - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/contracts/onboard-new-contract",
      component: OnboardNewContract,
      name: "onboardNewContract",
      meta: {
        title: "Contracts - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/contracts/:contractId",
      component: Contract,
      name: "contract",
      meta: {
        title: "Contracts - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/contracts/:contractId/edit",
      component: ContractEdit,
      name: "contractEdit",
      meta: {
        title: "Contracts - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/contract-facilities",
      component: ContractFacilities,
      name: "contractFacilities",
      meta: {
        title: "Contract Facilities - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/contract-facilities/create",
      component: ContractFacilitiesEdit,
      name: "contractFacilitiesCreate",
      meta: {
        title: "Contract Facilities Edit - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/contract-facilities/:contractFacilityId",
      component: ContractFacilitiesEdit,
      name: "contractFacilitiesEdit",
      meta: {
        title: "Contract Facilities Edit - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/account",
      component: AccountGeneral,
      name: "accountGeneral",
      meta: {
        title: "Account - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/account/invitations",
      component: AccountInvitations,
      name: "accountInvitations",
      meta: {
        title: "Account - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/account/security",
      component: AccountSecurity,
      name: "accountSecurity",
      meta: {
        title: "Account - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/team",
      component: TeamGeneral,
      name: "teamGeneral",
      meta: {
        title: "Team - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/team/roles",
      component: Roles,
      name: "roles",
      meta: {
        title: "Team - Mine.App",
        requiresAuth: true,
        access: {
          entity: "roles",
          action: "manage",
          fallback: "/team",
        },
      },
    },
    {
      path: "/team/roles/create",
      component: RoleEdit,
      name: "createRole",
      meta: {
        title: "Team - Mine.App",
        requiresAuth: true,
        access: {
          entity: "roles",
          action: "manage",
          fallback: "/team",
        },
      },
    },
    {
      path: "/team/roles/:roleId",
      component: Role,
      name: "role",
      meta: {
        title: "Team - Mine.App",
        requiresAuth: true,
        access: {
          entity: "roles",
          action: "manage",
          fallback: "/team",
        },
      },
    },
    {
      path: "/team/roles/:roleId/edit",
      component: RoleEdit,
      name: "editRole",
      meta: {
        title: "Team - Mine.App",
        requiresAuth: true,
        access: {
          entity: "roles",
          action: "manage",
          fallback: "/team",
        },
      },
    },
    {
      path: "/team/members/:memberId",
      component: TeamMember,
      name: "teamMember",
      meta: {
        title: "Team - Mine.App",
        requiresAuth: true,
        access: {
          entity: "members",
          action: "view",
          fallback: "/team",
        },
      },
    },
    {
      path: "/team/members",
      component: TeamMembers,
      name: "teamMembers",
      meta: {
        title: "Team - Mine.App",
        requiresAuth: true,
        access: {
          entity: "members",
          action: "view",
          fallback: "/team",
        },
      },
    },
    {
      path: "/team/invitations",
      component: TeamInvitations,
      name: "teamInvitations",
      meta: {
        title: "Team - Mine.App",
        requiresAuth: true,
        access: {
          entity: "members",
          action: "view",
          fallback: "/team",
        },
      },
    },
    {
      name: "alertEvents",
      path: "/alerts/events",
      component: AlertEvents,
      meta: {
        title: "Alerts - Mine.App",
        requiresAuth: true,
        access: {
          entity: "alerts",
          action: "view",
        },
      },
    },
    {
      name: "alertCreate",
      path: "/alerts/create",
      component: AlertEdit,
      meta: {
        title: "Alerts - Mine.App",
        requiresAuth: true,
        access: {
          entity: "alerts",
          action: "edit",
          fallback: "/alerts",
        },
      },
    },
    {
      name: "alert",
      path: "/alerts/:alertId",
      component: Alert,
      meta: {
        title: "Alerts - Mine.App",
        requiresAuth: true,
        access: {
          entity: "alerts",
          action: "view",
        },
      },
    },
    {
      name: "alertEdit",
      path: "/alerts/:alertId/edit",
      component: AlertEdit,
      meta: {
        title: "Alerts - Mine.App",
        requiresAuth: true,
        access: {
          entity: "alerts",
          action: "edit",
          fallback: "/alerts",
        },
      },
    },
    {
      name: "alerts",
      path: "/alerts",
      component: Alerts,
      meta: {
        title: "Alerts - Mine.App",
        requiresAuth: true,
        access: {
          entity: "alerts",
          action: "view",
        },
      },
    },
    {
      path: "/help",
      component: Help,
      name: "help",
      meta: {
        title: "Help - Mine.App",
      },
    },
    {
      path: "/help/faq",
      component: HelpFAQ,
      name: "helpFAQ",
      meta: {
        title: "Help - Mine.App",
      },
    },
    {
      path: "/reactor-admin/capacity",
      component: ReactorCapacity,
      name: "reactorAdminCapacity",
      meta: {
        title: "Reactor Capacity - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "/reactor-admin/contracts",
      component: ReactorContracts,
      name: "reactorAdminContracts",
      meta: {
        title: "Reactor Contracts - Mine.App",
        requiresAuth: true,
      },
    },
    {
      path: "*",
      component: PageNotFound,
      name: "pageNotFound",
      meta: {
        title: "Not Found - Mine.App",
      },
    },
  ],
});

// Called right before route navigation is confirmed (after in-component guards are resolved):
router.beforeResolve((to, from, next) => {
  if (to.meta.requiresAuth) {
    // This route requires auth
    // If not signed in, redirect to auth page
    if (!store.getters.authenticated && to.path !== "/sign-up") {
      // Query string to put in auth URL to pass old URL to be redirected back to
      // If old url just contained a "/", then don't pass anything in the query string
      const redirectQuery =
        to.fullPath !== "/" ? { redirect: to.fullPath } : {};

      next({
        path: "/sign-in",
        query: redirectQuery,
      });
      return;
    }
  }

  let access = to.meta.access;
  if (access) {
    let can = store.getters.can;
    if (!can[access.entity][access.action]) {
      next(access.fallback || "/");
      return;
    }
  }

  next();
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
